import { Button, Checkbox, Column, FileUploader, FileUploaderButton, FileUploaderDropContainer, Form, FormLabel, Grid, Row, Select, SelectItem, TextInput } from "carbon-components-react";
import imageToBase64 from "image-to-base64";
import { useState, useEffect } from "react";
import { connect, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import Padding from "../../components/Padding";
import UIShell from "../../components/UIShell";
import PageHelper from "../../helpers/Pagehelper";
import { ACCOUNT_TYPES, ACCOUNT_TYPES_UP } from "../../utils/constants";
import { createAccount } from "../../redux/actions/accountAction";

function AccountFormPage({ isLoading }) {
    const history = useHistory()
    const dispatch = useDispatch()
    const [formContent, setFormContent] = useState({
        firstName: undefined,
        lastName: undefined,
        email: undefined,
        password: undefined,
        accountType: ACCOUNT_TYPES.COMPANY,
        sendEmailNotification: false,
    })

    const submitForm = (e) => {
        e.preventDefault()

        dispatch(createAccount(formContent, () => {
            history.push("/accounts")
        }))
    }

    // const uploadProfilePicture = (v) => {
    //     PageHelper.getBase64(v.target.files[0], (_result) => setFormContent((_state) => ({
    //         ..._state,
    //         profilePicture: _result
    //     })))
    // }

    return (
        <UIShell breadcrumbs={[
            { name: "Home", link: "/" },
            { name: "Accounts", link: "/accounts" },
            { name: "Create" }
        ]}>
            <Grid>
                <Row>
                    <Column>
                        <Form onSubmit={submitForm}>
                            <TextInput
                                value={formContent.firstName}
                                onChange={(v) => setFormContent(_state => ({ ..._state, firstName: v.target.value }))}
                                data-modal-primary-focus
                                labelText="First Name"
                                required
                                style={{ marginBottom: '1rem' }}
                            />
                            <TextInput
                                value={formContent.lastName}
                                onChange={(v) => setFormContent(_state => ({ ..._state, lastName: v.target.value }))}
                                data-modal-primary-focus
                                labelText="Last Name"
                                required
                                style={{ marginBottom: '1rem' }}
                            />
                            <TextInput
                                value={formContent.email}
                                onChange={(v) => setFormContent(_state => ({ ..._state, email: v.target.value }))}
                                data-modal-primary-focus
                                labelText="Email"
                                type="email"
                                required
                                style={{ marginBottom: '1rem' }}
                            />
                            <TextInput
                                value={formContent.password}
                                onChange={(v) => setFormContent(_state => ({ ..._state, password: v.target.value }))}
                                data-modal-primary-focus
                                labelText="Password"
                                type="password"
                                required
                                style={{ marginBottom: '1rem' }}
                            />
                            <Select
                                value={formContent.accountType}
                                onChange={(v) => setFormContent(_state => ({ ..._state, accountType: v.target.value }))}
                                id="select-1" defaultValue={formContent.accountType} labelText="Account Type" style={{ marginBottom: '1rem' }}>
                                <SelectItem value={ACCOUNT_TYPES_UP.COMPANY} text={ACCOUNT_TYPES.COMPANY} />
                                <SelectItem value={ACCOUNT_TYPES_UP.CREATIVE} text={ACCOUNT_TYPES.CREATIVE} />
                                {/* <SelectItem value={ACCOUNT_TYPES_UP.ADMINISTRATOR} text={ACCOUNT_TYPES.ADMINISTRATOR} /> */}
                            </Select>

                            <Checkbox
                                id="send-email-checkbox"
                                labelText="Send email notification"
                                checked={formContent.sendEmailNotification}
                                onChange={(checked) => setFormContent(_state => ({ ..._state, sendEmailNotification: checked }))}
                                style={{ marginBottom: '1rem' }}
                            />


                            {/* <FileUploader
                                multiple={false}
                                onChange={uploadProfilePicture}
                                labelTitle="Upload Profile Picture" labelDescription="Maxium file upload is 500kb" title="Upload" buttonLabel="Upload" /> */}

                            <Padding top="1rem">
                                <Button disabled={isLoading} type="submit" kind="primary">Save</Button>
                                <Button onClick={() => history.push("/accounts")} kind="secondary">Cancel</Button>
                            </Padding>
                        </Form>
                    </Column>
                </Row>
            </Grid>
        </UIShell>
    )
}

const mapStateToProps = state => {
    return {
        isLoading: state.uxReducer.isLoading
    }
}

export default connect(mapStateToProps)(AccountFormPage)